import { useEffect, useRef, useState } from "react";
import { api, modoConsultorio, puede } from "../api.ts";
import { AvisoError, useAccion } from "../pantallas/comun.tsx";

interface Estado {
  activo: boolean; version?: string; titulo?: string; clausulas?: { titulo: string; texto: string }[];
  aceptado?: { en: string; por: string } | null;
}

/**
 * Contrato de licencia de uso de la versión para consultorios. Solo lo ve la administración del consultorio. Se lee y se acepta una vez por versión del texto
 * (queda constancia: quién, cuándo y la huella del texto). No bloquea el uso del programa: es una tarjeta en Inicio hasta que se acepta.
 */
export function ContratoLicencia() {
  const [e, setE] = useState<Estado | null>(null);
  const [abierto, setAbierto] = useState(false);
  const [facultad, setFacultad] = useState(false);
  const a = useAccion();
  const cerrar = useRef<HTMLButtonElement>(null);
  const visible = modoConsultorio() && puede("config:admin");
  useEffect(() => {
    if (!visible) return;
    api<Estado>("GET", "/api/contrato-licencia").then(setE).catch(() => undefined);
  }, [visible]);
  useEffect(() => { if (abierto) cerrar.current?.focus(); }, [abierto]);
  if (!visible || !e || !e.activo || e.aceptado) return null;

  async function aceptar() {
    const r = await a.correr(() => api<unknown>("POST", "/api/contrato-licencia/aceptar", { version: e!.version, declaraFacultad: facultad }));
    if (r !== undefined) { setE({ ...e!, aceptado: { en: new Date().toISOString(), por: "" } }); setAbierto(false); }
  }

  return (
    <>
      <section className="card" aria-labelledby="t-contrato-lic">
        <div className="fila" style={{ justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 8 }}>
          <h2 id="t-contrato-lic" style={{ margin: 0 }}>Contrato de licencia de Donna</h2>
          <span className="chip rojo">Pendiente de aceptar</span>
        </div>
        <p className="muted" style={{ margin: 0, fontSize: 13 }}>
          Es el contrato por el que usas Donna en tu consultorio: qué incluye la licencia, tus respaldos y que tus datos son solo tuyos. Léelo y acéptalo: queda constancia de quién lo aceptó y cuándo.
        </p>
        <div><button className="btn pri" onClick={() => setAbierto(true)}>Leer y aceptar</button></div>
      </section>
      {abierto && (
        <div className="modal-fondo" role="dialog" aria-modal="true" aria-labelledby="t-contrato-lic-texto" onKeyDown={(x) => { if (x.key === "Escape") setAbierto(false); }}>
          <section className="card aut-datos" style={{ maxHeight: "90vh", overflowY: "auto" }}>
            <div className="fila" style={{ justifyContent: "space-between", alignItems: "flex-start" }}>
              <h2 id="t-contrato-lic-texto" style={{ margin: 0 }}>{e.titulo}</h2>
              <button ref={cerrar} className="btn chico" onClick={() => setAbierto(false)}>Más tarde</button>
            </div>
            {e.clausulas?.map((c) => (
              <div key={c.titulo}><h3 style={{ margin: "10px 0 2px" }}>{c.titulo}</h3><p style={{ margin: "2px 0" }}>{c.texto}</p></div>
            ))}
            <label style={{ display: "block", marginTop: 12 }}>
              <input type="checkbox" checked={facultad} disabled={a.ocupado} onChange={(x) => setFacultad(x.target.checked)} />{" "}
              <b>Declaro que tengo facultad para representar al consultorio y acepto este contrato.</b>
            </label>
            <AvisoError error={a.error} />
            <div className="fila" style={{ flexWrap: "wrap", marginTop: 8 }}>
              <button className="btn pri" onClick={aceptar} disabled={a.ocupado || !facultad}>Aceptar el contrato</button>
            </div>
            <small className="muted">Versión {e.version}. Puedes pedir una copia escribiendo al equipo de Donna.</small>
          </section>
        </div>
      )}
    </>
  );
}
